import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Reveal app after mount (FOUC prevention)
requestAnimationFrame(() => {
  document.getElementById('root')?.classList.add('ready')
  document.getElementById('app-loader')?.classList.add('hidden')
})
